define(["exports", "./utils", "./dfn-map"], function (_exports, _utils, _dfnMap) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  // @ts-check
  // Module core/dfn
  // - Finds all <dfn> elements and populates conf.definitionMap to identify them.
  const name = "core/dfn";
  _exports.name = name;

  function run() {
    document.querySelectorAll("dfn").forEach(dfn => {
      const titles = (0, _utils.getDfnTitles)(dfn);
      (0, _dfnMap.registerDefinition)(dfn, titles); // Default to `dfn` as the type... other modules may override

      if (!dfn.dataset.dfnType) dfn.dataset.dfnType = "dfn"; // Only add `lt`s that are different from the text content

      if (titles.length === 1 && titles[0] === (0, _utils.norm)(dfn.textContent)) {
        return;
      }

      dfn.dataset.lt = titles.join("|");
    });
  }
});
//# sourceMappingURL=dfn.js.map